module.exports = __webpack_public_path__ + "static/media/avinash.8c594dc5.jpeg";